var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-no-data"},[_c('p',[_vm._v("您暂时还没有数据哦")])])
}]

export { render, staticRenderFns }